export default "__VITE_ASSET__BmJ_xDvo__"